module.exports = __webpack_public_path__ + "img/logo-mesri-2020.5d52a8a9.svg";